import { Ds } from "@accurx/design";

type AbuseWordCheckModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSendMessage: () => void;
};

export const AbuseWordCheckModal = ({
    isOpen,
    onClose,
    onSendMessage,
}: AbuseWordCheckModalProps) => {
    return (
        <Ds.Modal open={isOpen} onOpenChange={onClose}>
            <Ds.Modal.Section>
                <Ds.Flex flexDirection="column" gap="2">
                    <Ds.Modal.Title>
                        It looks like there is explicit language in your
                        message, likely due to a spelling mistake.
                    </Ds.Modal.Title>
                    <Ds.Text>
                        Please review your message before sending.
                    </Ds.Text>
                    <Ds.Flex justifyContent="flex-end" gap="2">
                        <Ds.Button
                            onClick={onSendMessage}
                            type="button"
                            appearance="secondary"
                        >
                            Send message
                        </Ds.Button>
                        <Ds.Button onClick={onClose} type="button">
                            Review message
                        </Ds.Button>
                    </Ds.Flex>
                </Ds.Flex>
            </Ds.Modal.Section>
        </Ds.Modal>
    );
};
